export default "/assets/images/mila-feed-05-thumbnail.7ae29f95acfc6d41.jpg";